import { callXmApi, isNewXmApiCall } from '@xmatters/xm-api/xmApiToken';
import bluebird from 'utils/bluebird';

// consider using httpServiceMiddleware instead of this!
// eslint-disable-next-line import/prefer-default-export
export function call(uri, options) {
  const fetchRequest = isNewXmApiCall(uri)
    ? callXmApi({ uri, options })
    : fetch(uri, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        // override any options fetch could get
        ...options,
      });

  // pass in parsed json as well as raw response
  // as we want to attempt to parse, but still inspect the status code later on
  return fetchRequest
    .then(resp =>
      bluebird.props({
        resp,
        json: resp.json(),
      }),
    )
    .then(({ resp, json }) => {
      // error status code
      if (!resp.ok) {
        // use `message` field from api, or use statusText if its undefined
        const err = new Error(json.message || resp.statusText);
        throw err;
      }

      return json;
    });
}
